import { User } from '@domain/models/account-settings/user.model';

export const GA4_INTERNAL_TRAFFIC_TYPE = 'internal';

// Team test affiliate (real Everflow id); only `internal` is sent to GA4, never the id
export const INTERNAL_TRAFFIC_AFFILIATE_ID = 216;

/**
 * EverflowAffiliate row id of affiliate 216 (seeded in registration-api, same in Stage and Prod).
 * Needed because User.AffiliateId stores that row id instead of the real affiliate id
 * (known bug in registration-api FunnelService.FillUser). If that bug is ever fixed,
 * update this check: User.AffiliateId would then hold 216 for test accounts.
 * Comparing affiliateId to 216 today would be wrong: row id 216 is another affiliate.
 */
export const INTERNAL_TRAFFIC_AFFILIATE_ROW_ID = 2;

/** True when the signed-in account was acquired through the team test affiliate. */
export function isInternalTrafficMember(member: User | null | undefined): boolean {
  if (!member) return false;
  return member.affiliateId === INTERNAL_TRAFFIC_AFFILIATE_ROW_ID || member.everflowRealAffiliateId === INTERNAL_TRAFFIC_AFFILIATE_ID;
}

export function resolveGa4TrafficType(member: User | null | undefined): string | undefined {
  return isInternalTrafficMember(member) ? GA4_INTERNAL_TRAFFIC_TYPE : undefined;
}
